import { useEffect } from 'react';
import { toggleHeaderSearch } from 'tradera/state/ui/reducer';
import useIsLoggedIn from 'tradera/hooks/use-is-loggedin';
import { useAppDispatch } from 'tradera/state/hooks';
import { useLocation } from 'tradera/hooks/use-location';
import { useUrlLocalizer } from 'tradera/lang/translate';

const ALWAYS_SHOW_SEARCH_ROUTES = ['/search', '/category'];
const NEVER_SHOW_SEARCH_ROUTES = ['/search/new'];

export const useHeaderSearchVisibility = () => {
    const dispatch = useAppDispatch();
    const { toLocalizedUrl } = useUrlLocalizer();
    const location = useLocation();
    const isLoggedIn = useIsLoggedIn();

    useEffect(() => {
        const path = location.pathname;

        // If the user is not logged in, always show the search form
        if (!isLoggedIn) {
            dispatch(toggleHeaderSearch(true));
            return;
        }

        // Check if we should never show search for this route
        if (
            NEVER_SHOW_SEARCH_ROUTES.some((route) =>
                toLocalizedUrl(path).startsWith(toLocalizedUrl(route)),
            )
        ) {
            dispatch(toggleHeaderSearch(false));
            return;
        }

        // Check if we should always show search for this route
        if (
            ALWAYS_SHOW_SEARCH_ROUTES.some((route) =>
                toLocalizedUrl(path).startsWith(toLocalizedUrl(route)),
            )
        ) {
            dispatch(toggleHeaderSearch(true));
            return;
        }

        // Default behavior - hide search
        dispatch(toggleHeaderSearch(false));
    }, [location.pathname, isLoggedIn, dispatch, toLocalizedUrl]);
};
